import Vue from "vue";
import getBaseUrl from "../config/baseUrl";

Vue.prototype.$search = new Vue({
  methods: {
    post(keyword, language = "en", filters) {
      let lang = language;

      if (lang === "pt") {
        lang = "pt-br";
      }

      let url = `${getBaseUrl()}search/${lang}?s=${keyword}&limit=32`;

      if (filters?.page) {
        url += `&page=${filters.page}`;
      }

      if (filters?.customers) {
        url += `&customer=${filters?.customers}`;
      }

      if (filters?.years) {
        url += `&year=${filters?.years}`;
      }

      if (filters?.offices) {
        url += `&office=${filters?.offices}`;
      }

      if (filters?.types) {
        url += `&type=${filters?.types}`;
      }

      return new Promise((resolve, reject) => {
        this.$http
          .get(url)
          .then((result) => resolve(result.data))
          .catch((error) => reject(error));
      });
    },
  },
});
